import type { CorvidSDKFactory } from '@wix/editor-elements-types/corvid';

export type CreateBaseSdkFactory = <T extends `$w.${string}`>(
  type: T,
) => CorvidSDKFactory;

export const createBaseSdk: CreateBaseSdkFactory = type => _api => {
  return {
    get type() {
      return type;
    },

    get parent() {
      // TODO: Parent component relationships are not yet implemented in the Builder Platform SDK.
      // The traditional corvid SDK uses metaData.getParent() but BuilderComponentSdkFactory
      // doesn't provide access to parent relationships through the current (getProps, setProps, getService) API.
      // This needs to be implemented when parent-child component relationships are supported.
      return null;
    },
  };
};
